const API_URL_ENV =
  process.env.REACT_APP_API_URL || "https://stageapi-simulations.meseekna.com"
const UI_V2_URL_ENV =
  process.env.REACT_APP_UI_V2_URL || "https://stage-simulations.meseekna.com"

export const TUTORIAL_ID_FAKE = 999_999_999
export const API_URL = API_URL_ENV.endsWith("/")
  ? API_URL_ENV.slice(0, -1)
  : API_URL_ENV
export const UI_V2_URL = UI_V2_URL_ENV.endsWith("/")
  ? UI_V2_URL_ENV.slice(0, -1)
  : UI_V2_URL_ENV
export const SAVEPOINT_TIMER = 2 * 60 // 2 minutes
export const NOTIFICATION_TIMER = 120000 // 2 minutes in milliseconds
const simIdMap: { [key: string]: { [key: string]: number } } = {
  production: {
    silverStreak: 100,
    rootsAndShoots: 101,
    coastarea: 102,
    croFashionRetail: 210,
    youngMedicalStudent: 212,
  },
  staging: {
    silverStreak: 100,
    rootsAndShoots: 101,
    coastarea: 102,
    croFashionRetail: 210,
    youngMedicalStudent: 212,
  },
}
export const SimulationIds = {
  ...simIdMap[process.env.REACT_APP_RUNNING_ENV || "staging"],
}

export default {
  API_URL,
  UI_V2_URL,
  TUTORIAL_ID_FAKE,
  SAVEPOINT_TIMER,
  NOTIFICATION_TIMER,
}

export enum RecruiterPortal {
  Composite = "composite",
  Performance = "performance",
  OverallPerformance = "overallPerformance",
  Benchmark = "benchmark",
}
